export const enum CustomRoutes {
  Metrics = 'metrics',
  Healthcheck = 'healthcheck',
  Category = 'category',
  Product = 'product',
  Search = 'search',
  Cart = 'cart',
  Checkout = 'checkout',
  Articles = 'articles',
  ArticlesDetail = 'articles-detail',
  LoginByCode = 'login-by-code',
  LoginByPassword = 'login-by-password',
  PersonalData = 'personal_data',
  UpdateProfile = 'update-profile',
  Orders = 'orders',
  Payments = 'payments',
  Order = 'order',
  AddressBook = 'address-book',
  OrderConfirmation = 'order-confirmation',
  About = 'about',
  Promo = 'promo',
  FreeDelivery = 'free_delivery',
  Pay = 'pay',
  Exchange = 'exchange',
  Contacts = 'contacts',
  Feedback = 'feedback',
  Coler = 'coler',
  Rassrochka = 'rassrochka',
  RassrochkaKrovliIFasada = 'raschet-krovli-i-fasada',
  BestOffers = 'best-offers',
  C = 'c',
  P = 'p',
  S = 's',
  Home = 'home',
  Comparison = 'comparison',
  AddCompany = 'add-company',
  CompaniesList = 'companies-list',
  OrderDocuments = 'order-documents',
  Wishlist = 'wishlist',
  Static = 'static',
  Smartedit = 'smartedit',

  Unknown = 'unknown',
}

const routes: [CustomRoutes, RegExp][] = [
  [CustomRoutes.Metrics, /(^|\/)metrics\/?$/],
  [CustomRoutes.Healthcheck, /(^|\/)healthcheck\/?$/],
  [CustomRoutes.Category, /(^|\/)([^/]+\/)?category\/[^/]+\/?$/],
  [CustomRoutes.Product, /(^|\/)([^/]+\/)?product\/[^/]+\/?$/],
  [CustomRoutes.Search, /(^|\/)([^/]+\/)?search\/[^/]+\/?$/],
  [CustomRoutes.Cart, /(^|\/)([^/]+\/)?cart\/?$/],
  [CustomRoutes.Checkout, /(^|\/)([^/]+\/)?checkout\/?$/],
  [CustomRoutes.Articles, /(^|\/)([^/]+\/)?articles\/?$/],
  [CustomRoutes.ArticlesDetail, /(^|\/)([^/]+\/)?articles\/[^/]+\/?$/],
  [CustomRoutes.LoginByCode, /(^|\/)([^/]+\/)?login\/by-code\/?$/],
  [CustomRoutes.LoginByPassword, /(^|\/)([^/]+\/)?login\/by-password\/?$/],
  [CustomRoutes.PersonalData, /(^|\/)([^/]+\/)?personal_data\/?$/],
  [CustomRoutes.UpdateProfile, /(^|\/)([^/]+\/)?my-account\/update-profile\/?$/],
  [CustomRoutes.Orders, /(^|\/)([^/]+\/)?my-account\/orders\/?$/],
  [CustomRoutes.Payments, /(^|\/)([^/]+\/)?my-account\/payments\/?$/],
  [CustomRoutes.Order, /(^|\/)([^/]+\/)?my-account\/order\/[^/]+\/?$/],
  [CustomRoutes.OrderDocuments, /(^|\/)([^/]+\/)?my-account\/order-documents\/[^/]+\/?$/],
  [CustomRoutes.AddressBook, /(^|\/)([^/]+\/)?my-account\/address-book\/?$/],
  [CustomRoutes.OrderConfirmation, /(^|\/)([^/]+\/)?order-confirmation\/?$/],
  [CustomRoutes.About, /(^|\/)([^/]+\/)?about\/?$/],
  [CustomRoutes.Promo, /(^|\/)([^/]+\/)?promo\/?$/],
  [CustomRoutes.FreeDelivery, /(^|\/)([^/]+\/)?free_delivery\/?$/],
  [CustomRoutes.Pay, /(^|\/)([^/]+\/)?pay\/?$/],
  [CustomRoutes.Exchange, /(^|\/)([^/]+\/)?exchange\/?$/],
  [CustomRoutes.Contacts, /(^|\/)([^/]+\/)?contacts\/?$/],
  [CustomRoutes.Feedback, /(^|\/)([^/]+\/)?feedback\/?$/],
  [CustomRoutes.Coler, /(^|\/)([^/]+\/)?coler\/?$/],
  [CustomRoutes.Rassrochka, /(^|\/)([^/]+\/)?rassrochka\/?$/],
  [CustomRoutes.RassrochkaKrovliIFasada, /(^|\/)([^/]+\/)?raschet-krovli-i-fasada\/?$/],
  [CustomRoutes.BestOffers, /(^|\/)([^/]+\/)?best-offers\/?$/],
  [CustomRoutes.C, /(^|\/)([^/]+\/)?c\/[^/]+\/?$/],
  [CustomRoutes.P, /(^|\/)([^/]+\/)?p\/[^/]+\/?$/],
  [CustomRoutes.S, /(^|\/)([^/]+\/)?s\/[^/]+\/?$/],
  [CustomRoutes.Comparison, /(^|\/)([^/]+\/)?comparison\/?$/],
  [CustomRoutes.AddCompany, /(^|\/)([^/]+\/)?add-company\/?$/],
  [CustomRoutes.CompaniesList, /(^|\/)([^/]+\/)?my-company\/companies-list\/?$/],
  [CustomRoutes.Wishlist, /(^|\/)([^/]+\/)?wishlist\/?$/],
  [CustomRoutes.Static, /\.(css|js|svg|png|webp|woff|ttf|webmanifest|json|map)$/],
  [CustomRoutes.Smartedit, /(^|\/)([^/]+\/)?cx-preview\/?$/],

  // Главная должна быть в конце, иначе может неккоректно определиться
  [CustomRoutes.Home, /(^|\/)(([a-zA-Z]+\/?)?$)/],
];

/**
 * Функция служит для аггрегации роутов на сайта.
 *
 * Так как контент сайта прилетает динамически, заранее мы не можем знать к какому роуту
 * относится контент.
 * Требуется для локальной аналитики (метрики, ошибки)
 *
 * @param path путь без параметров
 * @param defaultValue дефолтное значение, если маска не найдена
 * @returns роут
 */
export function getRoute(path: string, defaultValue: string = CustomRoutes.Unknown): string {
  return routes.find(([, regex]) => regex.test(path))?.[0] ?? defaultValue;
}
